import { render } from "./pb-sitetext.vue?vue&type=template&id=40feb3d8"
import script from "./pb-sitetext.vue?vue&type=script&lang=js"
export * from "./pb-sitetext.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__